import styles from "./product-filters.module.css"

const categories = [
  { id: "all", label: "All Products", icon: "🎮" },
  { id: "digital", label: "Digital Keys", icon: "🔑" },
  { id: "ingame", label: "In-Game Items", icon: "💎" },
  { id: "gear", label: "Gaming Gear", icon: "🎧" },
  { id: "merch", label: "Merchandise", icon: "👕" },
]

export default function ProductFilters({searchTerm, setSearchTerm }) {
  return (
    <div className={styles.filtersSection}>
      <div className={styles.searchBox}>
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
        <span className={styles.searchIcon}>🔍</span>
      </div>

      {/* <div className={styles.categoryFilters}>
        <h3 className={styles.filterTitle}>Categories</h3>
        <div className={styles.categoryGrid}>
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`${styles.categoryBtn} ${selectedCategory === cat.id ? styles.active : ""}`}
              onClick={() => setSelectedCategory(cat.id)}
            >
              <span className={styles.categoryIcon}>{cat.icon}</span>
              <span className={styles.categoryLabel}>{cat.label}</span>
            </button>
          ))}
        </div>
      </div> */}
    </div>
  )
}
